import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, IconButton, ShareLinkPopup, Tooltip, AppText } from '@streem/ui-react';
import { useCallback, useRef, useState } from 'react';
import { useShareLink } from '../../../../hooks/use_share_link';
import { useMediaBreakpoint } from '../../../../hooks/use_media_breakpoint';
// eslint-disable-next-line no-restricted-imports
import theme from '@streem/ui-react/src/styles/theme';
export const ShareLinkButton = ({ roomSid, anonymousShareEnabled, companyName }) => {
    const containerRef = useRef(null);
    const [hover, setHover] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({
        top: 0,
        right: 0,
    });
    const handleMouseEnter = useCallback(() => {
        setHover(true);
    }, []);
    const handleMouseLeave = useCallback(() => {
        setHover(false);
    }, []);
    const handleShareButtonClick = useCallback(() => {
        const shadowOffset = -28;
        const verticalOffset = -29;
        setPopupPosition({
            top: verticalOffset,
            right: shadowOffset,
        });
        setShowPopup(true);
        setHover(false);
    }, []);
    const [link, refreshLink] = useShareLink({ roomSid, anonymousShareEnabled });
    const { isSmallScreen } = useMediaBreakpoint();
    return (_jsxs("div", { children: [_jsx(Tooltip, { placement: "left", fallbackPlacements: ['left', 'top'], showTooltip: hover, message: _jsx(AppText, { size: "small", style: { whiteSpace: 'nowrap' }, children: "Create share link" }), borderRadius: "6px", children: _jsx(ShareLinkIconButton, { label: 'Create share link', iconName: 'ShareIconThick', fill: theme.colors.grey60, iconSize: "25", onClick: handleShareButtonClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }) }), _jsx("div", { ref: containerRef, style: { position: 'relative' }, children: _jsx(ShareLinkPopup, { open: showPopup, position: popupPosition, onClose: () => setShowPopup(false), containerRef: containerRef, companyName: companyName, link: link || '', refreshLink: refreshLink, anonymousShareEnabled: anonymousShareEnabled, cardSize: isSmallScreen ? '365' : '415' }) })] }));
};
const ShareLinkIconButton = styled(IconButton) `
    opacity: 0.9;
    margin-bottom: 8px;

    &:active {
        opacity: 0.64;
        transform: scale(0.92);
    }
    &:hover:enabled {
        cursor: pointer;
        background: #f2f8fe;
    }
`;
//# sourceMappingURL=share_link_button.js.map